import React from 'react'
import {Select} from "antd";
import api from "../../api";
import {useAuth} from "../../auth";

export default function TaskAssigneeSelect({users, task}) {

    const {user} = useAuth()

    function handleChange(user_id) {
        api.updateTask(task.id, {user_id: user_id}).then((response) => {
            console.log(response)
        }).catch((error) => {
            console.error(error)
        })
    }

    if (!users || users.length === 0) {
        return null;
    }

    if (!task) {
        return null;
    }



    return (
        <Select onChange={handleChange} style={{width: '150px'}} defaultValue={task.user_id}
                options={users.filter((u) => {
                    return u.is_active
                }).map((u) => {
                    return {
                        value: u.id,
                        label: u.id === user.id ? `${u.name} (Jij)` : u.name,
                    }
                })}>
        </Select>
    );
}